import { isMatrixCellValueEmpty } from "../../../utils/forms-functions";
export var matrixCellUniquenessKey = function (val) {
    if (val === null || val === undefined) {
        return "";
    }
    if (typeof val === "object") {
        return JSON.stringify(val);
    }
    return String(val);
};
export var getMatrixDropdownRowKeys = function (element, value) {
    var rows = element.rows;
    if (Array.isArray(rows) && rows.length > 0) {
        return rows.map(function (row) { return (typeof row === "string" ? row : row.value); });
    }
    return Object.keys(value !== null && value !== void 0 ? value : {});
};
export var isColumnReadOnly = function (col, fieldReadOnly, columnDisabledByEnableIf) {
    return (fieldReadOnly ||
        col.readOnly === true ||
        Boolean(columnDisabledByEnableIf === null || columnDisabledByEnableIf === void 0 ? void 0 : columnDisabledByEnableIf[col.name]));
};
export var validateMatrixDropdownRequiredColumns = function (value, element, columns, elementRequired, fieldReadOnly, columnDisabledByEnableIf, columnRequiredByRequiredIf) {
    if (!value || typeof value !== "object") {
        return false;
    }
    var obj = value;
    var rowKeys = getMatrixDropdownRowKeys(element, obj);
    for (var _i = 0, rowKeys_1 = rowKeys; _i < rowKeys_1.length; _i++) {
        var rowKey = rowKeys_1[_i];
        var row = obj[rowKey];
        if (typeof row !== "object" || row === null) {
            return false;
        }
        for (var _a = 0, columns_1 = columns; _a < columns_1.length; _a++) {
            var col = columns_1[_a];
            var colReadOnly = isColumnReadOnly(col, fieldReadOnly, columnDisabledByEnableIf);
            var cellRequired = !colReadOnly &&
                (elementRequired ||
                    col.isRequired === true ||
                    Boolean(columnRequiredByRequiredIf === null || columnRequiredByRequiredIf === void 0 ? void 0 : columnRequiredByRequiredIf[col.name]));
            if (!cellRequired)
                continue;
            var cellVal = row[col.name];
            if (isMatrixCellValueEmpty(cellVal)) {
                return false;
            }
        }
    }
    return true;
};
export var validateMatrixDropdownUniqueColumns = function (value, element, columns, fieldReadOnly, columnDisabledByEnableIf) {
    if (!value || typeof value !== "object") {
        return true;
    }
    var obj = value;
    var rowKeys = getMatrixDropdownRowKeys(element, obj);
    for (var _i = 0, columns_2 = columns; _i < columns_2.length; _i++) {
        var col = columns_2[_i];
        if (!col.isUnique ||
            isColumnReadOnly(col, fieldReadOnly, columnDisabledByEnableIf)) {
            continue;
        }
        var seen = new Set();
        for (var _a = 0, rowKeys_2 = rowKeys; _a < rowKeys_2.length; _a++) {
            var rowKey = rowKeys_2[_a];
            var row = obj[rowKey];
            if (typeof row !== "object" || row === null)
                continue;
            var cellVal = row[col.name];
            if (isMatrixCellValueEmpty(cellVal))
                continue;
            var key = matrixCellUniquenessKey(cellVal);
            if (seen.has(key)) {
                return false;
            }
            seen.add(key);
        }
    }
    return true;
};
export var validateMatrixDynamicCells = function (value, columns, elementRequired, fieldReadOnly, columnDisabledByEnableIf, columnRequiredByRequiredIf) {
    if (!Array.isArray(value))
        return false;
    for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
        var item = value_1[_i];
        if (typeof item !== "object" || item === null) {
            return false;
        }
        var row = item;
        for (var _a = 0, columns_3 = columns; _a < columns_3.length; _a++) {
            var col = columns_3[_a];
            var colReadOnly = isColumnReadOnly(col, fieldReadOnly, columnDisabledByEnableIf);
            var cellRequired = !colReadOnly &&
                (elementRequired ||
                    col.isRequired === true ||
                    Boolean(columnRequiredByRequiredIf === null || columnRequiredByRequiredIf === void 0 ? void 0 : columnRequiredByRequiredIf[col.name]));
            if (!cellRequired)
                continue;
            if (isMatrixCellValueEmpty(row[col.name])) {
                return false;
            }
        }
    }
    return true;
};
export var validateMatrixDynamicUniqueColumns = function (value, columns, fieldReadOnly, columnDisabledByEnableIf) {
    if (!Array.isArray(value)) {
        return true;
    }
    for (var _i = 0, columns_4 = columns; _i < columns_4.length; _i++) {
        var col = columns_4[_i];
        if (!col.isUnique ||
            isColumnReadOnly(col, fieldReadOnly, columnDisabledByEnableIf)) {
            continue;
        }
        var seen = new Set();
        for (var _a = 0, value_2 = value; _a < value_2.length; _a++) {
            var item = value_2[_a];
            if (typeof item !== "object" || item === null)
                continue;
            var row = item;
            var cellVal = row[col.name];
            if (isMatrixCellValueEmpty(cellVal))
                continue;
            var key = matrixCellUniquenessKey(cellVal);
            if (seen.has(key)) {
                return false;
            }
            seen.add(key);
        }
    }
    return true;
};
